import React, {useContext} from 'react';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';

import {Tag, Container} from 'components';

import styles from './FiltersTags.module.scss';
import Context from '../../context';
import {reducerFilters} from '../../reducers';

export const FiltersTags = () => {
  const {filters, dispatchFilters} = useContext(Context);

  const tags = flatten(values(filters));

  const handleClick = value => {
    const filter = value.split('--')[0];

    dispatchFilters({
      type: reducerFilters.actionTypes.remove,
      payload: {filter, value},
    });
  };

  if (isEmpty(tags) || isEmpty(compact(tags.map(item => item.label))))
    return null;

  return (
    <Container className={styles.wrap}>
      {tags.map(
        item =>
          item.label && (
            <Tag
              key={item.value}
              closable
              onClick={handleClick}
              value={item.value}
            >
              {item.label}
            </Tag>
          ),
      )}
    </Container>
  );
};

FiltersTags.propTypes = {};

FiltersTags.defaultProps = {};
